import styled from 'styled-components';
import {UsefulLinksItemDefaultBox} from "./useful-links-item.default.box";


export const UsefulLinksItemMrGreenBox = styled(UsefulLinksItemDefaultBox)`
    &:hover {
        background-color: ${props => props.theme.colors.background};
    }
`;
